import React, { useEffect, useState } from 'react'
import { Container } from './styled'
import { useParams } from 'react-router-dom'
import SideMenu from '../sideMenu/view';
import BookingList from '../bookingList/view'
import BookingPlanList from '../bookingPlanList/view'
import VenueSettings from '../venueSettings/view';
import { getVenue, getCommunitiesForMember } from 'api'
import { Grid, Box } from '@mui/material'
import { defaultVenueImage } from '../../../../assets/images/defaults'
import { getEntityImageUrl } from '../../../../api/utils';


const VenueSingle = () => {

  const params = useParams()
  const { slug } = params
  const [venue, setVenue] = useState(null)
  const [communities, setCommunities] = useState([])
  const [drawerOpen, setDrawerOpen] = useState(true);
  

  const [value, setValue] = useState(0);
  
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };



  function getCommunityInfo() {
    getCommunitiesForMember().then(r => {
      setCommunities(r.communities)
    })
      .catch(console.error)
  }


  function getVenueInfo() {
    getVenue(slug).then(r => {
      setVenue(r)
    })
      .catch(console.error)
  }



  useEffect(() => {
    getVenueInfo(true)
    getCommunityInfo(true)
  }, [])

  const avatar = getEntityImageUrl(venue, 'thumbnail', defaultVenueImage)
  return (
    <Container>
      {/* Global toolbar */}
      {/* Community header */}
      <Grid container spacing={{ xs: 1, md: 2 }}>
        {/* Left Menu */}
        <Grid item xs={12} md={2}>
          <SideMenu slug={slug} open={drawerOpen} onClose={handleDrawerToggle} changeTab={handleChange} avatar={avatar} title={venue?.name} subtitle={null} />
        </Grid>
        <Grid item xs={12} md={10}>
          <Box
            sx={{ 
              flexGrow: 1, 
              p: { xs: 1, md: 3 }  // Reduced padding on mobile
            }}
          >
            {value === 0 && <BookingList slug={slug} communities={communities}/>}
            {value === 1 && <BookingPlanList slug={slug} communities={communities}/>}
            {value === 5 && <VenueSettings slug={slug}/>}
          </Box>
        </Grid>
      </Grid>

    </Container>
  )
}

VenueSingle.propTypes = {}

export default VenueSingle
